var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-modal',{attrs:{"title":_vm.$t('synchronization.delete_warning'),"visible":_vm.isOpened,"ok-text":_vm.$t('common.delete'),"ok-button-props":{
    props: {
      type: 'danger',
      loading: _setup.deleteRequest,
      disabled: !_setup.deleteConfirmationValueIsValid
    }
  }},on:{"ok":_setup.handleDeleteSync,"cancel":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"popover-body__input"},[_c('a-input',{attrs:{"placeholder":_vm.$t('common.enter_text')},model:{value:(_setup.deleteConfirmationValue),callback:function ($$v) {_setup.deleteConfirmationValue=$$v},expression:"deleteConfirmationValue"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }